import { useCallback } from 'react';

import type { Placement, Padding, Rect } from '@popperjs/core';

// Arrow Modifier
type PaddingFunction = ({
  popper,
  reference,
  placement,
}: {
  popper: Rect;
  reference: Rect;
  placement: Placement;
}) => Padding;

const arrowPadding: PaddingFunction = ({ placement }) => {
  if (placement.includes('-start') || placement.includes('-end')) {
    return 16;
  } else {
    return 0;
  }
};

export const useArrowModifier = (arrowElement?: HTMLDivElement | null) => ({
  name: 'arrow',
  options: {
    element: arrowElement,
    padding: useCallback(arrowPadding, []),
  },
});

// Flip Modifer
export const useFlipModifier = () => ({ name: 'flip', enabled: true });

// Offest Modifier
type OffsetsFunction = ({
  popper,
  reference,
  placement,
}: {
  popper: Rect;
  reference: Rect;
  placement: Placement;
}) => [number, number];

const offset: OffsetsFunction = ({ placement }: { placement: Placement }) => {
  if (placement.includes('-start')) {
    return [-16, 8];
  } else if (placement.includes('-end')) {
    return [16, 8];
  } else {
    return [0, 8];
  }
};

export const useOffsetModifier = () => ({
  name: 'offset',
  options: {
    offset: useCallback(offset, []),
  },
});
